export const productName = 'MEGA PACK ENERGÍAS RENOVABLES LISTO';
export const productImage =
  'https://cdn.magicpatterns.com/uploads/fuPaqg99mCTA6uW5PjnSqn/ChatGPT_Image_6_sept_2026,_19_21_23.png';

export const checkoutUrl = 'https://megapack-energias-renovables-listo.impultienda.ar/checkout';

export const price = 'USD 19,00';
export const priceBefore = 'USD 40,00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70,00';

export const included = [
  'Tomo 1 — Fundamentos y Transición Energética',
  'Tomo 2 — Energía Solar Fotovoltaica',
  'Tomo 3 — Energía Eólica',
  'Tomo 4 — Energía Hidráulica',
  'Tomo 5 — Biomasa, Biogás y Biocombustibles',
  'Tomo 6 — Geotermia y Otras Fuentes',
  'Tomo 7 — Almacenamiento y Sistemas Híbridos',
  'Tomo 8 — Diseño y Dimensionamiento',
  'Tomo 9 — Planificación y Proyectos 2026',
  'Bono 1 — 150 Actividades y Prácticas',
  'Bono 2 — 100 Problemas Resueltos',
  'Bono 3 — Kit de Evaluaciones Completo',
  'Bono 4 — 50 Proyectos Integradores',
  'Bono 5 — Guía Visual de Componentes',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];

export const systemNegatives = [
  'No es teoría copiada de un manual desactualizado.',
  'No es una colección de prácticas sueltas sin coherencia.',
  'No es material que tengas que adaptar entero.',
];

export const closingLines = [
  'Sin más noches buscando cómo explicar conceptos de energías renovables complejos',
  'Sin más clases armadas de apuro con material que no funciona',
  'Sin más alumnos desconectados que no entienden para qué sirven las energías renovables',
  'Sin más fines de semana perdidos construyendo material desde cero',
  'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos',
];
